<template>
<div class="z-body">
 	<header class="z-header">
		<div><router-link to="/user/login"><img src="../../assets/sysbars/left.png" /></router-link></div>
		<div>{{$t('找回密码')}}</div>
		<div></div>
	</header>
	<!-- <section>
	  <div class="inputBox">
		<div style="width: 10%;">
		  <img class="z-icon" src="../../assets/icon/register/name.png">
		</div>
		<div style="width: 60%;">
		  <input autocomplete="new-password" v-model="loginName" style="outline:none;font-size: 16px" :placeholder="$t('客户号')">
		</div>
		<div style="width: 30%;text-align: right">
		  <div class="z-icon"></div>
		</div>
	  </div>
	</section>
	<section>
	  <div class="inputBox">
		<div style="width: 10%;">
		  <img class="z-icon" src="../../assets/icon/register/mobile.png">
		</div>
		<div style="width: 60%;">
		  <input autocomplete="new-password" v-model="phoneNumber" style="outline:none;font-size: 16px" :placeholder="$t('手机号')">
		</div>
		<div style="width: 30%;text-align: right">
		  <div class="z-icon"></div>
		</div>
	  </div>
	</section> -->
	<section>
	  <div class="inputBox">
		<div style="width: 10%;">
		  <img class="z-icon" src="../../assets/icon/register/email.png">
		</div>
		<div style="width: 60%;">
		  <input autocomplete="new-password" v-model="email" style="outline:none;font-size: 16px" :placeholder="$t('邮箱')">
		</div>
		<div style="width: 30%;text-align: right">
		  <div class="z-icon"></div>
		</div>
	  </div>
	</section>
	<section>
	  <div style="padding-right: 0px" class="inputBox" >
		<div style="width: 10%;">
		  <img class="z-icon" src="../../assets/icon/register/smscode.png">
		</div>
		<div style="border-right: 1px solid black;width: 60%;height: 100%;line-height: 60px">
		  <input autocomplete="new-password" v-model="code" style="outline:none;font-size: 16px" :placeholder="$t('验证码')">
		</div>
		<div v-if="!sendOnOff" @click="getEmailCode" style="height: 100%;line-height: 60px;width: 30%;text-align: center;font-size: 15px">
		  {{$t('获取验证码')}}
		</div>
		<div v-if="sendOnOff" style="height: 100%;line-height: 60px;width: 30%;text-align: center;font-size: 15px">
		  {{coutDown}}
		</div>
	  </div>
	</section>
	<section style="margin-top: 10px">
	  <div class="inputBox" style="justify-content:flex-start;">
		<div style="width: 10%;">
		  <img class="z-icon" src="../../assets/icon/register/password.png">
		</div>
		<div style="width: 80%;">
		  <input autocomplete="new-password" v-model="passWord1" type="password" style="outline:none;font-size: 16px;width:100%;" :placeholder="$t('设置新登录密码')">
		</div>
	  </div>
	</section>
	<section>
	  <div class="inputBox" style="justify-content:flex-start;">
		<div style="width: 10%;">
		  <img class="z-icon" src="../../assets/icon/register/password.png">
		</div>
		<div style="width: 80%;">
		  <input autocomplete="new-password" v-model="passWord2" type="password" style="outline:none;font-size: 16px;width:100%;" :placeholder="$t('确认新登录密码')">
		</div>
	  </div>
	</section>
	<section style="text-align: center;padding:20px 0px;">
	  <div @click="findPassWord" class="common-btn">{{$t('确认')}}</div>
	</section>
  </div>
</template>

<script>
	export default {
		name: 'findPassWord',
		data() {
			return {
			  loginName:"",
			  phoneNumber:"",
			  code:"",
			  email:"",
			  passWord1:"",
			  passWord2:"",
			  sendOnOff:false,
			  coutDown:60
			}
		},
		mounted() {

		},
		methods: {
			// 获取短信验证码
		  getCode:function () {
			let _this=this
			if(this.phoneNumber==""){
			  this.$store.commit('layer',this.$t('请输入')+this.$t('手机号'))
			}else{
			  this.post('api/Sms/Send.html', {
				mobile: this.phoneNumber,
				cateid:2
			  }).then((res) => {

				if(res.code==0){
				  this.sendOnOff=true
				  let timer = setInterval(function () {
					if(_this.coutDown==0){
					  _this.coutDown=60
					  _this.sendOnOff=false
					  clearInterval(timer)
					}else {
					  _this.coutDown=_this.coutDown-1
					}
				  },1000)
				}
				this.$store.commit('layer',res.msg)
			  })
			}
		  },
		  // 获取邮箱验证码
		  getEmailCode:function () {
			let _this=this
			if(this.email==""){
			  this.$store.commit('layer',this.$t('请输入')+this.$t('邮箱'))
			}else{
			  this.post('api/index/sendEmailCode.html', {
				email: this.email,
				cateid:2
			  }).then((res) => {

				if(res.code==0){
				  this.sendOnOff=true
				  let timer = setInterval(function () {
					if(_this.coutDown==0){
					  _this.coutDown=60
					  _this.sendOnOff=false
					  clearInterval(timer)
					}else {
					  _this.coutDown=_this.coutDown-1
					}
				  },1000)
				}
				this.$store.commit('layer',res.msg)
			  })
			}
		  },
		  // 提交
		  findPassWord:function () {
			let _this=this
			if(this.email=="" || this.code=="" || this.passWord1=="" || this.passWord2==""){
			  this.$store.commit('layer',this.$t('部分信息未填写'))
			}else if(this.passWord1 != this.passWord2){
			  this.$store.commit('layer',this.$t('两组密码不相同'))
			}else{
			  this.post('api/index/FindPwd.html', {
				email:this.email,
				name:this.loginName,
				mobile: this.phoneNumber,
				newpwd:this.passWord2,
				code:this.code
			  }).then((res) => {
				this.$store.commit('layer',res.msg)
				if (res.code ==0) {
					this.jump('/user/login')
				}
			  })
			}
		  }
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .inputBox{
	/* background-color: #424355; */
  background-color: #fff;
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 60px;
	padding:0 30px 0 30px;
	margin-bottom:2px;
	border-bottom: 1px solid #28293D;
  }
</style>



// WEBPACK FOOTER //
// src/pages/user/findPassWord.vue